import apiService from '../services/ApiService';

// Base de los hubs de SignalR. Los hubs viven en la raíz del backend (/hubs/...),
// no bajo /api, así que se quita ese sufijo venga de la variable que venga.
const getHubBaseUrl = () =>
  (
    process.env.REACT_APP_API_URL ||
    apiService.baseURL ||
    window.location.origin
  )
    .replace(/\/+$/, '')
    .replace(/\/api$/i, '');

export default getHubBaseUrl;
